module.exports = __webpack_public_path__ + "img/home_bg.4bc9cf54.jpg";